import { createSlice } from '@reduxjs/toolkit';

export const driverSlice = createSlice({
  name: 'driver',
  initialState: {
    drivers: [],
  },
  reducers: {
    addDrivers: (state, action) => {
      state.drivers = action.payload
    },
  },
});

export const { addDrivers } = driverSlice.actions;

export const selectDrivers = state => state.driver.drivers;

export default driverSlice.reducer;
